"use client";

import React from "react";
import { Mousewheel, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import CourseSection from "../course-section";
import CourseSwiperNav from "../course-swiper-nav";

import DemoVideo from "./demo-video";
import DemoVideosModal from "./demo-videos-modal";

import useMoengageEventTracker from "@/hooks/use-moengage";
import EVENT_NAME from "@/hooks/use-moengage/event-name";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute";

function CourseDemoVideos({ courseId, demoVideos }) {
  const trackMoengageEvent = useMoengageEventTracker();

  const prevNavRef = React.useRef(null);
  const nextNavRef = React.useRef(null);

  const [swiper, setSwiper] = React.useState(null);
  const [videoId, setVideoId] = React.useState(null);

  const videos = React.useMemo(() => {
    return demoVideos?.[0]?.demoVideos;
  }, [demoVideos]);

  if (!videos?.length) return null;

  const handleOnDemoVideoPlay = (demoVideoId) => () => {
    setVideoId(demoVideoId);

    trackMoengageEvent(EVENT_NAME.DEMO_VIDEO_CLICKED, {
      [EVENT_ATTRIBUTE.COURSE_ID]: courseId,
      [EVENT_ATTRIBUTE.DEMO_VIDEO_ID]: demoVideoId,
    });
  };

  return (
    <CourseSection
      id="demo-videos"
      title="Demo Videos"
      action={
        <CourseSwiperNav
          swiper={swiper}
          prevNavRef={prevNavRef}
          nextNavRef={nextNavRef}
        />
      }
    >
      <Swiper
        modules={[Navigation, Mousewheel]}
        slidesPerView={1.6}
        spaceBetween={16}
        slidesOffsetAfter={16}
        onSwiper={setSwiper}
        mousewheel={{ forceToAxis: true }}
        breakpoints={{
          600: {
            slidesPerView: 2,
            slidesOffsetAfter: 0,
          },
        }}
        className="-mr-4 lg:mr-0"
      >
        {videos.map((video) => (
          <SwiperSlide key={video.id}>
            <DemoVideo
              video={video}
              onPlayClick={handleOnDemoVideoPlay(video.id)}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <DemoVideosModal
        courseId={courseId}
        videos={videos}
        videoId={videoId}
        setVideoId={setVideoId}
      />
    </CourseSection>
  );
}

export default CourseDemoVideos;
